module.exports = __webpack_public_path__ + "img/male12.dee2deda.jpeg";